module.exports = __webpack_public_path__ + "static/img/introDownload.ae2b8b17.png";